export const notification = {
  notification: '通知',
  allNotifications: '所有通知',
  general: '常规',
  settings: '设置',
  newChatRequest: {
    youHaveANewChatRequest: '您有一个新的聊天请求！！！',
    youHaveTransferredChatRequest: '您有一个已转移的聊天请求！！！',
    acceptRequest: '接受请求',
    discardRequest: '丢弃请求'
  },
  notificationList: {
    name: '姓名',
    message: '消息',
    noDataFound: {
      notification: '通知',
      noNotificationsFound: '找不到通知！',
    }
  },
  notificationSetting: {
    userMessage: '用户消息',
    receiveNotificationsWhenUserSendMessage: '每当用户发送消息时接收通知',
    liveChatRequest: '实时聊天请求',
    receiveNotificationsWhenUserRequestLiveChat: '每当用户请求实时聊天时接收通知',
    newLead: '新线索',
    receiveNotificationsWhenNewLeadCreated: '每当新线索创建时接收通知',
    assignedOnly: '仅分配',
    allUsers: '所有用户',
    customizeWhichNotificationsYouWantToRecieve: '自定义要接收的通知',
    youCanCustomizeSettingForTheNotifications: '您可以自定义通知的设置',
    receiveNotifications: '接收通知',
    desktopNotifications: '桌面通知',
    mobilePushNotifications: '移动推送通知',
    discard: '丢弃',
    update: '更新',
    appTooltip: {
      TOOLTIP_NEW_MESSAGE_DESKTOP_NOTIFICATION: '在桌面上发送新消息的通知',
      TOOLTIP_NEW_MESSAGE_MOBILE_NOTIFICATION: '通过移动发送新消息的通知',
      TOOLTIP_NEW_LEAD_DESKTOP_NOTIFICATION: '在桌面上发送新线索的通知',
      TOOLTIP_NEW_LEAD_MOBILE_NOTIFICATION: '通过移动发送新线索的通知',
      TOOLTIP_LIVE_CHAT_DESKTOP_NOTIFICATION: '在桌面上发送实时聊天的通知',
      TOOLTIP_LIVE_CHAT_MOBILE_NOTIFICATION: '通过移动发送实时聊天的通知',
      TOOLTIP_RECEIVED_NOTIFICATION: '选择您希望收到通知的消息类型'
    }
  }
};
